export default function TextArea({
  disabled = false,
  title,
  placeholder,
  value,
  onChange,
}) {
  return (
    <div className="w-full space-y-1">
      <div className="text-xs text-[#424242] font-normal leading-[20px] tracking-[0%]">
        {title}
      </div>
      <textarea
        disabled={disabled}
        rows={10}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full text-sm placeholder-[#A4A7AE] text-[#414651] focus:outline-none focus:border-[#414651] border border-[#C2C2C2] bg-[#FDFDFD] py-2 px-3 resize-none rounded-[10px]"
      />
    </div>
  );
}
